import React from "react";
import loader from "../assests/loader.gif";

const Loader = (props) => {
    return (
        <div className="loader" data-testid="loaderr">
            <img src={loader} alt='loader' />
        </div>
    )
}

export default Loader